import React from "react";
import C_box from "../Components/C_box";
import { BsPhone } from "react-icons/bs";
import { SiGmail } from "react-icons/si";
import { GrLocation } from "react-icons/gr";
import Form from "../Components/Form";
import Navbar from "../SharedPage/Navbar";

const Contact = () => {
  return (
    <div>
      <Navbar />
      <div
        data-aos="flip-up"
        data-aos-duration="1500"
        data-aos-anchor-placement="top-center"
        className="w-10/12 mx-auto mt-10 min-h-screen"
        id="contact"
      >
        <h2 className="text-center mb-20 text-secondary tracking-widest text-4xl">
          <pre>Contact</pre>
        </h2>
        <div
          data-aos-delay="1000"
          data-aos-duration="1500"
          data-aos="flip-right"
          className="mx-auto gap-2  grid grid-cols-1 lg:grid-cols-3 lg:w-11/12 "
        >
          <C_box
            icon={<BsPhone />}
            info1={"+8801819499739"}
            info2={"+8801819499739"}
          />
          <C_box
            icon={<SiGmail />}
            info1={"kibria.official1@gmail.com"}
            info2={"kibriahossain934@gmail.com"}
          />
          <C_box
            icon={<GrLocation />}
            info1={"Gazipur, Dhaka"}
            info2={"Bangladesh"}
          />
        </div>
        <div className="lg:w-6/12 lg:mx-auto">
          <Form />
        </div>
      </div>
    </div>
  );
};

export default Contact;
